import { rgba } from 'polished';

// NEW COLORS
// Gray group
const white = '#FFFFFF';
const offWhite = '#FAFAFA';
const softGray = '#E4E4E4';
const gray = '#8F9197';
const darkGray = '#4A4A4A';
const superDark = '#000000';

// Blue / Primary group
const blue50 = '#F5F7FA';
const blue100 = '#E6F0FF';
const blue200 = '#D9E9FF';
const blue300 = '#B1D1FF';
const blue400 = '#036BFF';
const blue500 = '#0360E6';
const blue600 = '#0256CC';
const blue700 = '#0250BF';
const blue800 = '#024099';
const blue900 = '#013073';
const blue950 = '#012559';

// Purple
const purple50 = '#FDFAFF';
const purple100 = '#F5E6FF';
const purple200 = '#F0D9FF';
const purple300 = '#DFB0FF';
const purple400 = '#9900FF';
const purple500 = '#8A00E6';
const purple600 = '#7A00CC';
const purple700 = '#7300BF';
const purple800 = '#5C0099';
const purple900 = '#450073';
const purple950 = '#360059';

// Teal / MrWork Employees group
const teal50 = '#E6F9F9';
const teal100 = '#CCF2F4';
const teal200 = '#99E6EA';
const teal300 = '#4DC8CF';
const teal400 = '#00A2AE';
const teal500 = '#008B96';
const teal600 = '#00747E';
const teal700 = '#005E66';
const teal800 = '#004950';
const teal900 = '#003338';
const teal950 = '#001D1F';

// Red / Error group
const red100 = '#FFEAE6';
const red200 = '#FFE0D9';
const red300 = '#FFBFB0';
const red400 = '#FF3100';
const red500 = '#E62C00';
const red600 = '#CC2700';
const red700 = '#BF2500';
const red800 = '#991D00';
const red900 = '#731600';
const red950 = '#591100';

// Green / Success group
const green100 = '#ECF6EB';
const green200 = '#E2F2E1';
const green300 = '#C4E4C1';
const green400 = '#40A736';
const green500 = '#3A9631';
const green600 = '#33862B';
const green700 = '#307D29';
const green800 = '#266420';
const green900 = '#1D4B18';
const green950 = '#163A13';

// Yellow / Leads/ Warning group
const yellow100 = '#FFFAE6';
const yellow200 = '#FFF7D9';
const yellow300 = '#FFEEB0';
const yellow400 = '#FFC800';
const yellow500 = '#E6B400';
const yellow600 = '#CCA000';
const yellow700 = '#BF9600';
const yellow800 = '#997800';
const yellow900 = '#735A00';
const yellow950 = '#594600';

// Orange / Brands group
const orange100 = '#FFF0E6';
const orange200 = '#FFE9D9';
const orange300 = '#FFD1B0';
const orange400 = '#FF6A00';
const orange500 = '#E65F00';
const orange600 = '#CC5500';
const orange700 = '#BF5000';
const orange800 = '#994000';
const orange900 = '#733000';
const orange950 = '#592500';

// Picton / Jobs group
const picton100 = '#EBF6FF';
const picton200 = '#E0F2FF';
const picton300 = '#C0E4FF';
const picton400 = '#33A8FF';
const picton500 = '#2E97E6';
const picton600 = '#2986CC';
const picton700 = '#267EBF';
const picton800 = '#1F6599';
const picton900 = '#174C73';
const picton950 = '#123B59';

// Base group
const primary = blue400;
const ebon = '#26253B';
const luckyPoint = '#1D1668';
const gradient = `linear-gradient(135deg, ${luckyPoint}, ${primary})`;
const gradient2 = `linear-gradient(180deg, ${luckyPoint}, #0D074F)`;

// MrWork group
const mrWorkBg = teal50;
const mrWorkLight = teal100;
const mrWork = teal400;

// Leads group
const leadsLight = yellow100;
const leads = yellow400;

// Brands group
const brandsLight = orange100;
const brands = orange400;

// Jobs group
const jobsLight = picton100;
const jobs = picton400;

// Surface / background group
const background = blue50;
const surface = white;
const surfaceSub = offWhite;
const surfaceSidebar = gradient2;

// Text colors group
const heading = luckyPoint;
const title = darkGray;
const text = ebon;
const subText = gray;
const link = blue400;

// Border colors group
const border = blue100;
const borderActive = blue400;

// Alert colors group
// Success group
const successBg = green100;
const success = green400;
const successText = green800;

// Warning group
const warningBg = yellow100;
const warning = yellow400;
const warningText = yellow900;

// Danger group
const dangerBg = red100;
const danger = red400;
const dangerText = red800;

// Info group
const infoBg = blue100;
const info = blue400;
const infoText = blue800;

// Old colors
const alabaster = '#F8F8F8';
const alabaster2 = '#FCFCFC';
const alabaster3 = '#FAFAFA';
const alabaster4 = '#F7F7F7';
const alto = '#dbdbdb';
const aliceBlue = '#FAFDFF';
const anakiwa = '#7FD3FF';
const antiFlashWhite = '#F2F2F1';
const apple = '#40A736';
const apple2 = '#3FC92B';
const athensGray = '#F0F2F4';
const athensGrayDark = '#eeeef1';
const atlantis = '#7ECC49';
const azure = '#0092FF';
const azureRadiance = '#04A2FF';
const aztec = '#0B141A';
const aquaHaze = '#eaf1f4';
const babyBlue = '#84CBFF';
const bittersweet = '#ff795e';
const black = '#000';
const blackHaze = '#FAFBFB';
const blazeOrange = '#FF6A00';
const boulder = '#757575';
const eastBay = '#3F3A74';
const blue = '#0533FF';
const trueBlue = '#0075CC';
const blueRibbon = '#036bff';
const scienceBlue = '#0256CC';
const midnightBlue = '#013073';
const bombay = '#AAACB0';
const brightGray = '#EDEDED';
const buddhaGold = '#d19900';
const cadetBlue = '#A2AFBE';
const capeCod = '#343A38';
const catskillWhite = '#f5f7fa';
const cerise = '#D82976';
const chambray = '#385898';
const cinnamon = '#735A00';
const chardon = '#FFF4F2';
const chineseGold = '#CC9900';
const crusta = '#ff883e';
const cyan = '#03E2FF';
const darkSilver = '#6A6C73';
const deepCerulean = '#0077B5';
const deepKoamaru = '#1F1673';
const dodgerBlue = '#32a8ff';
const dolphin = '#676676';
const domino = '#957862';
const doveGray = '#6E6E6E';
const drWhite = '#fafafa';
const dustGray = '#979797';
const eerieBlack = '#181826';
const earlyDawn = '#FFF9EC';
const earlyDawn2 = '#FFFAE6';
const ebony = '#101828';
const ebonyClay = '#26253B';
const emperor = '#505050';
const emerald = '#57D163';
const fairPink = '#FFEAE6';
const floralWhite = '#FFFAF0';
const forestGreen = '#1C883C';
const gallery = '#F0F0F0';
const geyser = '#CBD4DF';
const ghost = '#CED4DA';
const ghost2 = '#CACED4';
const ghost3 = '#C8CED4';
const gold = '#fad000';
const goldenTainoi = '#FFD157';
const grayLegacy = '#939393';
const graySecond = '#8F8F8F';
const gunPowder = '#3C3B4F';
const hibiscus = '#B8256F';
const hippieGreen = '#E6FFE352';
const iron = '#DFE2E5';
const brilliantAzure = '#33A8FF';
const ironDark = '#CED0D4';
const jacarta = '#2A246C';
const jaffa = '#EB983F';
const jumbo = '#7D7C89';
const laPalma = '#18a419';
const lochmara = '#0075CC';
const deepCove = '#0D074F';
const lunarGreen = '#364336';
const malibu = '#56B6FE';
const malibu2 = '#76AEF8';
const manatee = '#8F9197';
const mantis = '#78C171';
const mercury = '#E4E4E4';
const mischka = '#D2D0E1';
const mischka2 = '#D4D3D8';
const mountainMeadow = '#18B6A6';
const mystic = '#E2E6ED';
const neonCarrot = '#FF9933';
const nobel = '#b7b7b7';
const onahau = '#C2E5FF';
const osloGray = '#85888E';
const outrageousOrange = '#ff5b38';
const orangeSoda = '#F25F3F';
const orchid = '#DE5CDE';
const poloBlue = '#8595cb';
const porcelain = '#f5f6f7';
const punch = '#dc3545';
const purpleHeart = '#6D2FC6';
const spanishGray = '#8F9197';
const quarterSpanishWhite = '#F6F0E1';
const regentGray = '#8696A0';
const rollingStone = '#7F8287';
const saffron = '#F1BF25';
const saddleBrown = '#594600';
const scarlet = '#FF3100';
const grenadier = '#CC2700';
const indianTan = '#591100';
const cedarWoodFinish = '#731600';
const wafer = '#E4D9D6';
const sauvignon = '#FFF5F3';
const scarpaFlow = '#525163';
const seashell = '#F1F1F1';
const selago = '#e0eafa';
const selectiveYellow = '#FFBA00';
const serenade = '#FFF0E6';
const shark = '#1D2129';
const shuttleGray = '#616770';
const silver = '#cccccc';
const silverSecond = '#B8B8B8';
const silverChalice = '#A5A5A5';
const silverSand = '#CBCCCD';
const snowFlurry = '#D9FDD3';
const solitude = '#EDF8FF';
const spunPearl = '#A9A8B1';
const stormGray = '#747481';
const sunglow = '#ffc62d';
const supernova = '#FFC800';
const teaGreen = '#D1F4CC';
const thunderbird = '#BB131B';
const toreaBay = '#14339B';
const transparent = 'transparent';
const tundora = '#4A4A4A';
const waterloo = '#7B7B8D';
const whisper = '#F1F0F8';
const whisperBlue = '#E4E9F1';
const whiteLilac = '#F5F7FB';
const trackWhite = '#fdfdfd';
const zumthor = '#EFF6FF';
const zumthor2 = '#E6F0FF';
const zircon = '#F9FCFF';
const zircon2 = '#F3F8FF';
const lightGrayishBlue = '#F8F9FB';
const frenchPass = '#C0E4FF';
const romantic = '#FFD1B0';
const buttermilk = '#FFEEB0';
const yellow = '#FFFC00';
const vermilion = '#FF4500';
const red = '#ff0000';
const cornflowerBlue = '#5695F6';
const chateauGreen = '#3BA756';
const whitePointer = '#FDFAFF';
const waxFlower = '#FFBFB0';
const congressBlue = '#024099';

export const COLOR: Record<string, string> = {
    //NEW COLORS
    // Gray group
    white,
    offWhite,
    softGray,
    gray,
    darkGray,
    superDark,

    // Blue / Primary group
    blue50,
    blue100,
    blue200,
    blue300,
    blue400,
    blue500,
    blue600,
    blue700,
    blue800,
    blue900,
    blue950,

    // Purple
    purple50,
    purple100,
    purple200,
    purple300,
    purple400,
    purple500,
    purple600,
    purple700,
    purple800,
    purple900,
    purple950,

    // Teal group / MrWork Employees group
    teal50,
    teal100,
    teal200,
    teal300,
    teal400,
    teal500,
    teal600,
    teal700,
    teal800,
    teal900,
    teal950,

    // Red / Error group
    red100,
    red200,
    red300,
    red400,
    red500,
    red600,
    red700,
    red800,
    red900,
    red950,

    // Green / Success group
    green100,
    green200,
    green300,
    green400,
    green500,
    green600,
    green700,
    green800,
    green900,
    green950,

    // Yellow / Leads/ Warning group
    yellow100,
    yellow200,
    yellow300,
    yellow400,
    yellow500,
    yellow600,
    yellow700,
    yellow800,
    yellow900,
    yellow950,

    // Orange / Brands group
    orange100,
    orange200,
    orange300,
    orange400,
    orange500,
    orange600,
    orange700,
    orange800,
    orange900,
    orange950,

    // Picton / Jobs group
    picton100,
    picton200,
    picton300,
    picton400,
    picton500,
    picton600,
    picton700,
    picton800,
    picton900,
    picton950,

    // Base group
    primary,
    ebon,
    luckyPoint,
    gradient,
    gradient2,

    // MrWork group
    mrWorkBg,
    mrWorkLight,
    mrWork,

    // Leads group
    leadsLight,
    leads,

    // Brands group
    brandsLight,
    brands,

    // Jobs group
    jobsLight,
    jobs,

    // Surface / background group
    background,
    surface,
    surfaceSub,
    surfaceSidebar,

    // Text colors group
    heading,
    title,
    text,
    subText,
    link,

    // Border colors group
    border,
    borderActive,

    // Alert colors group
    // Success group
    successBg,
    success,
    successText,

    // Warning group
    warningBg,
    warning,
    warningText,

    // Danger group
    dangerBg,
    danger,
    dangerText,

    // Info group
    infoBg,
    info,
    infoText,

    // OLD colors
    alabaster,
    alabaster2,
    alabaster3,
    alabaster4,
    alto,
    alto0: rgba(alto, 0),
    alto02: rgba(alto, 0.2),
    alto03: rgba(alto, 0.3),
    aliceBlue,
    anakiwa,
    antiFlashWhite,
    apple,
    apple2,
    apple01: rgba(apple, 0.1),
    apple012: rgba(apple, 0.12),
    apple04: rgba(apple, 0.4),
    apple07: rgba(apple, 0.7),
    apple08: rgba(apple, 0.8),
    athensGray,
    athensGray02: rgba(athensGray, 0.2),
    athensGray03: rgba(athensGray, 0.3),
    athensGray06: rgba(athensGray, 0.6),
    athensGray09: rgba(athensGray, 0.9),
    athensGrayDark,
    atlantis,
    atlantis016: rgba(atlantis, 0.16),
    atlantis032: rgba(atlantis, 0.32),
    azure,
    azureRadiance,
    azureRadiance02: rgba(azureRadiance, 0.2),
    azureRadiance03: rgba(azureRadiance, 0.3),
    azureRadiance04: rgba(azureRadiance, 0.4),
    azureRadiance05: rgba(azureRadiance, 0.5),
    azureRadiance095: rgba(azureRadiance, 0.95),
    aztec,
    aquaHaze,
    aztec012: rgba(aztec, 0.12),
    aztec014: rgba(aztec, 0.14),
    babyBlue,
    bittersweet,
    bittersweet03: rgba(bittersweet, 0.3),
    black,
    black001: rgba(black, 0.01),
    black003: rgba(black, 0.03),
    black004: rgba(black, 0.04),
    black005: rgba(black, 0.05),
    black006: rgba(black, 0.06),
    black008: rgba(black, 0.08),
    black01: rgba(black, 0.1),
    black03: rgba(black, 0.3),
    black04: rgba(black, 0.4),
    black048: rgba(black, 0.48),
    black06: rgba(black, 0.6),
    black08: rgba(black, 0.8),
    black09: rgba(black, 0.9),
    black014: rgba(black, 0.14),
    black016: rgba(black, 0.16),
    blackHaze,
    blazeOrange,
    blazeOrange01: rgba(blazeOrange, 0.1),
    blazeOrange04: rgba(blazeOrange, 0.4),
    blazeOrange05: rgba(blazeOrange, 0.5),
    blazeOrange08: rgba(blazeOrange, 0.8),
    boulder,
    eastBay,
    blue,
    blue016: rgba(blue, 0.16),
    blue029: rgba(blue, 0.29),
    trueBlue,
    blueRibbon,
    blueRibbon008: rgba(blueRibbon, 0.08),
    blueRibbon01: rgba(blueRibbon, 0.1),
    blueRibbon012: rgba(blueRibbon, 0.12),
    blueRibbon014: rgba(blueRibbon, 0.14),
    blueRibbon015: rgba(blueRibbon, 0.15),
    blueRibbon016: rgba(blueRibbon, 0.16),
    blueRibbon03: rgba(blueRibbon, 0.3),
    blueRibbon033: rgba(blueRibbon, 0.33),
    blueRibbon032: rgba(blueRibbon, 0.32),
    blueRibbon04: rgba(blueRibbon, 0.4),
    blueRibbon08: rgba(blueRibbon, 0.8),
    buttermilk,
    scienceBlue,
    midnightBlue,
    bombay,
    brightGray,
    buddhaGold,
    buddhaGold05: rgba(buddhaGold, 0.5),
    buddhaGold08: rgba(buddhaGold, 0.8),
    cinnamon,
    cadetBlue,
    capeCod,
    catskillWhite,
    catskillWhite05: rgba(catskillWhite, 0.5),
    catskillWhite04: rgba(catskillWhite, 0.4),
    catskillWhite06: rgba(catskillWhite, 0.6),
    catskillWhite07: rgba(catskillWhite, 0.7),
    catskillWhite08: rgba(catskillWhite, 0.8),
    catskillWhite09: rgba(catskillWhite, 0.9),
    cerise,
    cerise012: rgba(cerise, 0.12),
    cerise08: rgba(cerise, 0.8),
    chambray,
    chambray06: rgba(chambray, 0.6),
    chardon,
    chineseGold,
    crusta,
    cyan,
    congressBlue,
    cyan012: rgba(cyan, 0.12),
    cyan016: rgba(cyan, 0.16),
    darkSilver,
    deepCerulean,
    deepKoamaru,
    deepKoamaru05: rgba(deepKoamaru, 0.5),
    deepKoamaru08: rgba(deepKoamaru, 0.8),
    dodgerBlue,
    dodgerBlue0: rgba(dodgerBlue, 0),
    dodgerBlue003: rgba(dodgerBlue, 0.03),
    dodgerBlue004: rgba(dodgerBlue, 0.03),
    dodgerBlue008: rgba(dodgerBlue, 0.08),
    dodgerBlue01: rgba(dodgerBlue, 0.1),
    dodgerBlue012: rgba(dodgerBlue, 0.12),
    dodgerBlue03: rgba(dodgerBlue, 0.3),
    dodgerBlue04: rgba(dodgerBlue, 0.4),
    dodgerBlue05: rgba(dodgerBlue, 0.5),
    dodgerBlue06: rgba(dodgerBlue, 0.6),
    dodgerBlue08: rgba(dodgerBlue, 0.8),
    dolphin,
    domino,
    domino016: rgba(domino, 0.16),
    domino032: rgba(domino, 0.32),
    doveGray,
    doveGray01: rgba(doveGray, 0.1),
    doveGray07: rgba(doveGray, 0.7),
    doveGray08: rgba(doveGray, 0.8),
    drWhite,
    dustGray,
    dustGray01: rgba(dustGray, 0.1),
    dustGray02: rgba(dustGray, 0.2),
    earlyDawn,
    earlyDawn2,
    ebony,
    ebonyClay,
    ebonyClay008: rgba(ebonyClay, 0.08),
    ebonyClay01: rgba(ebonyClay, 0.1),
    ebonyClay012: rgba(ebonyClay, 0.12),
    ebonyClay032: rgba(ebonyClay, 0.32),
    ebonyClay02: rgba(ebonyClay, 0.2),
    ebonyClay04: rgba(ebonyClay, 0.4),
    ebonyClay05: rgba(ebonyClay, 0.5),
    ebonyClay06: rgba(ebonyClay, 0.6),
    ebonyClay08: rgba(ebonyClay, 0.8),
    eerieBlack,
    emerald,
    emperor,
    emperor016: rgba(emperor, 0.16),
    emperor032: rgba(emperor, 0.32),
    fairPink,
    floralWhite,
    forestGreen,
    forestGreen012: rgba(forestGreen, 0.12),
    forestGreen016: rgba(forestGreen, 0.16),
    forestGreen032: rgba(forestGreen, 0.32),
    forestGreen08: rgba(forestGreen, 0.8),
    frenchPass,
    gallery,
    gallery05: rgba(gallery, 0.5),
    geyser,
    ghost,
    ghost03: rgba(ghost, 0.3),
    ghost04: rgba(ghost, 0.4),
    ghost2,
    ghost3,
    gold,
    gold016: rgba(gold, 0.16),
    gold032: rgba(gold, 0.32),
    goldenTainoi,
    grayLegacy,
    graySecond,
    gray02: rgba(gray, 0.2),
    gray05: rgba(gray, 0.5),
    gray08: rgba(gray, 0.8),
    gunPowder,
    hibiscus,
    hibiscus016: rgba(hibiscus, 0.16),
    hibiscus032: rgba(hibiscus, 0.32),
    hippieGreen,
    hippieGreen032: rgba(hippieGreen, 0.32),
    iron,
    iron08: rgba(iron, 0.8),
    ironDark,
    brilliantAzure,
    brilliantAzure03: rgba(brilliantAzure, 0.3),
    brilliantAzure04: rgba(brilliantAzure, 0.4),
    jacarta,
    jaffa,
    jaffa05: rgba(jaffa, 0.5),
    jumbo,
    laPalma,
    laPalma002: rgba(laPalma, 0.02),
    lochmara,
    luckyPoint009: rgba(luckyPoint, 0.09),
    luckyPoint005: rgba(luckyPoint, 0.05),
    luckyPoint01: rgba(luckyPoint, 0.1),
    luckyPoint012: rgba(luckyPoint, 0.12),
    luckyPoint03: rgba(luckyPoint, 0.3),
    luckyPoint04: rgba(luckyPoint, 0.4),
    luckyPoint05: rgba(luckyPoint, 0.5),
    luckyPoint08: rgba(luckyPoint, 0.8),
    deepCove,
    lunarGreen,
    lunarGreen006: rgba(lunarGreen, 0.06),
    malibu,
    malibu2,
    manatee,
    manatee02: rgba(manatee, 0.2),
    manatee04: rgba(manatee, 0.4),
    manatee05: rgba(manatee, 0.5),
    manatee048: rgba(manatee, 0.48),
    manatee065: rgba(manatee, 0.65),
    manatee08: rgba(manatee, 0.8),
    mantis,
    mantis02: rgba(mantis, 0.2),
    mercury,
    mercury03: rgba(mercury, 0.3),
    mischka,
    mischka2,
    mountainMeadow,
    mystic,
    neonCarrot,
    neonCarrot016: rgba(neonCarrot, 0.16),
    neonCarrot032: rgba(neonCarrot, 0.32),
    nobel,
    onahau,
    osloGray,
    orangeSoda,
    orchid,
    orchid016: rgba(orchid, 0.16),
    orchid032: rgba(orchid, 0.32),
    outrageousOrange,
    outrageousOrange008: rgba(outrageousOrange, 0.08),
    outrageousOrange01: rgba(outrageousOrange, 0.1),
    outrageousOrange012: rgba(outrageousOrange, 0.12),
    outrageousOrange02: rgba(outrageousOrange, 0.2),
    outrageousOrange03: rgba(outrageousOrange, 0.3),
    outrageousOrange032: rgba(outrageousOrange, 0.32),
    outrageousOrange04: rgba(outrageousOrange, 0.4),
    outrageousOrange05: rgba(outrageousOrange, 0.5),
    outrageousOrange06: rgba(outrageousOrange, 0.6),
    outrageousOrange07: rgba(outrageousOrange, 0.7),
    outrageousOrange08: rgba(outrageousOrange, 0.8),
    poloBlue,
    porcelain,
    punch,
    punch016: rgba(punch, 0.16),
    punch032: rgba(punch, 0.32),
    purpleHeart,
    purpleHeart012: rgba(purpleHeart, 0.12),
    purpleHeart016: rgba(purpleHeart, 0.16),
    purpleHeart08: rgba(purpleHeart, 0.8),
    spanishGray,
    quarterSpanishWhite,
    regentGray,
    rollingStone,
    romantic,
    saffron,
    saddleBrown,
    saffron012: rgba(saffron, 0.12),
    saffron02: rgba(saffron, 0.2),
    saffron08: rgba(saffron, 0.8),
    scarlet,
    scarlet01: rgba(scarlet, 0.1),
    scarlet06: rgba(scarlet, 0.6),
    scarlet08: rgba(scarlet, 0.8),
    scarlet056: rgba(scarlet, 0.56),
    grenadier,
    indianTan,
    cedarWoodFinish,
    wafer,
    sauvignon,
    scarpaFlow,
    scarpaFlow04: rgba(scarpaFlow, 0.4),
    seashell,
    selago,
    selectiveYellow,
    selectiveYellow04: rgba(selectiveYellow, 0.4),
    serenade,
    shark,
    shuttleGray,
    shuttleGray06: rgba(shuttleGray, 0.6),
    silver,
    silver016: rgba(silver, 0.16),
    silver032: rgba(silver, 0.32),
    silverSecond016: rgba(silverSecond, 0.16),
    silverSecond032: rgba(silverSecond, 0.32),
    silverChalice,
    silverChalice04: rgba(silverChalice, 0.4),
    silverSand,
    snowFlurry,
    solitude,
    spunPearl,
    stormGray,
    sunglow,
    sunglow01: rgba(sunglow, 0.1),
    sunglow03: rgba(sunglow, 0.3),
    sunglow08: rgba(sunglow, 0.8),
    supernova,
    supernova04: rgba(supernova, 0.4),
    teaGreen,
    thunderbird,
    thunderbird012: rgba(thunderbird, 0.12),
    thunderbird08: rgba(thunderbird, 0.8),
    toreaBay,
    toreaBay04: rgba(toreaBay, 0.4),
    transparent,
    tundora,
    tundora001: rgba(tundora, 0.01),
    tundora002: rgba(tundora, 0.02),
    tundora003: rgba(tundora, 0.03),
    tundora004: rgba(tundora, 0.04),
    tundora006: rgba(tundora, 0.06),
    tundora008: rgba(tundora, 0.08),
    tundora01: rgba(tundora, 0.1),
    tundora011: rgba(tundora, 0.11),
    tundora012: rgba(tundora, 0.12),
    tundora015: rgba(tundora, 0.15),
    tundora016: rgba(tundora, 0.16),
    tundora02: rgba(tundora, 0.2),
    tundora03: rgba(tundora, 0.3),
    tundora04: rgba(tundora, 0.4),
    tundora05: rgba(tundora, 0.5),
    tundora06: rgba(tundora, 0.6),
    tundora07: rgba(tundora, 0.7),
    tundora08: rgba(tundora, 0.8),
    waterloo,
    waterloo02: rgba(waterloo, 0.2),
    whisper,
    whisperBlue,
    whiteLilac,
    white008: rgba(white, 0.08),
    white02: rgba(white, 0.2),
    white024: rgba(white, 0.24),
    white05: rgba(white, 0.5),
    white06: rgba(white, 0.6),
    white07: rgba(white, 0.7),
    white075: rgba(white, 0.75),
    white08: rgba(white, 0.8),
    white09: rgba(white, 0.9),
    zumthor,
    zumthor2,
    zumthor202: rgba(zumthor2, 0.2),
    zircon,
    zircon2,
    lightGrayishBlue,
    yellow,
    vermilion,
    red,
    cornflowerBlue,
    chateauGreen,
    whitePointer,
    waxFlower,
    trackWhite,
};
